import { render, staticRenderFns } from "./FileUploadPublic.vue?vue&type=template&id=2e6c3c96"
import script from "./FileUploadPublic.vue?vue&type=script&lang=js"
export * from "./FileUploadPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6c3c96')) {
      api.createRecord('2e6c3c96', component.options)
    } else {
      api.reload('2e6c3c96', component.options)
    }
    module.hot.accept("./FileUploadPublic.vue?vue&type=template&id=2e6c3c96", function () {
      api.rerender('2e6c3c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileUploadPublic.vue"
export default component.exports